// extracted by mini-css-extract-plugin
export default {"wrapperSpinner":"style_wrapperSpinner__XzW+9","spinner":"style_spinner__vIX9P","preloader":"style_preloader__2Jo7T"};